import React from 'react'

import { H1 } from '@guiker/components-library'
import { useTranslation } from '@guiker/i18n'

import { ErrorPage } from '../ErrorPage/ErrorPage'
import { I18nProvider } from '../I18nProvider'

const BaseExpiredLink: React.FC = () => {
  const { t } = useTranslation('expiredLink')

  return (
    <ErrorPage
      illustration={<H1 textAlign='center'>{t('header')}</H1>}
      primaryText={t('primaryText')}
      secondaryText={t('secondaryText')}
    />
  )
}

export const ExpiredLink: React.FC = () => {
  return (
    <I18nProvider>
      <BaseExpiredLink />
    </I18nProvider>
  )
}
